import { render, staticRenderFns } from "./QueryPolicySummary.vue?vue&type=template&id=21b55fc4&scoped=true&"
import script from "./QueryPolicySummary.vue?vue&type=script&lang=js&"
export * from "./QueryPolicySummary.vue?vue&type=script&lang=js&"
import style0 from "./QueryPolicySummary.vue?vue&type=style&index=0&id=21b55fc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b55fc4",
  null
  
)

export default component.exports